import React from 'react';
import Footer from '../../components/Footer/Footer';
import './FooterSection.css';

export default function FooterSection() {
  return (
    <div className="footer-section-wrapper">
      <Footer />
    </div>
  );
}
